// extracted by mini-css-extract-plugin
export default {"LinkedPullRequestToken":"linked-pr-token-module__LinkedPullRequestToken--AHa9_"};